import type { GetUserResponse, UserTransformed } from 'src/types/user';

export const transformGetUserResponse: (res: GetUserResponse) => UserTransformed = (res) => ({
  ...res,
  isAdmin: res.org === 'ZINGBRAIN',
  isSandbox: res.org === 'sandbox',
  // zingPlatformIdsCanAccess: ['6c1cf4d5-8d23-4e5a-8d61-6007d193db30'],
});
